import { Button, Card, Space, Typography, message } from 'antd';
import { useEffect, useState } from 'react';
import { api } from '../../api/client';
import HtmlEditorField from '../../components/HtmlEditorField';
import { USER_PRIVACY_POLICY_BODY_HTML } from '@taxima/shared';
import { htmlForEditor, wrapWebviewHtml } from '../../utils/webviewHtml';

const SETTING_KEY = 'privacy_passenger_html';

const defaultPrivacyHtml = USER_PRIVACY_POLICY_BODY_HTML;

export default function PrivacyPolicyEditorPage() {
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [exists, setExists] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get<{ settingKey: string; settingValue: string | null }>(
          `/admin/settings/${SETTING_KEY}`,
        );
        const raw = data.settingValue?.trim() ?? '';
        setExists(Boolean(raw));
        setHtml(raw ? htmlForEditor(data.settingValue ?? '') : defaultPrivacyHtml);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Card loading={loading}>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div>
          <Typography.Title level={4} style={{ marginBottom: 4 }}>
            私隱政策 HTML
          </Typography.Title>
          <Typography.Paragraph type="secondary" style={{ marginBottom: 0 }}>
            公開網址：
            <Typography.Link href="/privacy" target="_blank">
              /privacy
            </Typography.Link>
            （PROD：
            <Typography.Link href="https://app.hktaketaxi.online/privacy" target="_blank">
              app.hktaketaxi.online/privacy
            </Typography.Link>
            ；UAT：
            <Typography.Link href="https://flytaxi.hkcodai.space/privacy" target="_blank">
              flytaxi.hkcodai.space/privacy
            </Typography.Link>
            ）
            {exists ? ' · 編輯後儲存即可更新。' : ' · 尚未建立，儲存後即可在網上查看。'}
          </Typography.Paragraph>
        </div>
        <HtmlEditorField value={html} onChange={setHtml} />
        <Space>
          <Button
            type="primary"
            loading={saving}
            onClick={async () => {
              setSaving(true);
              try {
                await api.put(`/admin/settings/${SETTING_KEY}`, {
                  value: wrapWebviewHtml(html),
                });
                setExists(true);
                message.success(exists ? '已更新' : '已新增');
              } finally {
                setSaving(false);
              }
            }}
          >
            {exists ? '儲存修改' : '新增並儲存'}
          </Button>
          <Button
            onClick={() => {
              setHtml(defaultPrivacyHtml);
              message.info('已載入預設範本（尚未儲存）');
            }}
          >
            載入預設範本
          </Button>
        </Space>
      </Space>
    </Card>
  );
}
